export default {
  refresh: '刷新',
  close: '關閉',
  closeOthers: '關閉其它',
  closeAll: '關閉所有'
}
